import React, { useEffect, useState } from "react";
import "./DashboardHeader.scss";
import { FiBell } from "react-icons/fi";
import DP from "../../assets/profilePlaceholder.jpg";
import Dropdown from "react-bootstrap/Dropdown";
import { IoIosArrowDown } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserDetailApi } from "../../services/common";
import { getToken, setJwtToken } from "../../config/AxiosInstance";
import { setShowAuth } from "../../store/slices/showAuthSlice";
import { useDispatch, useSelector } from "react-redux";
import LogoutModal from "../modals/LogoutModal";
import { toastMessage } from "../../utils/toastMessage";
import CustomModal from "../modals/CustomModal";
import { fetchMeetAuthApi } from "../../services/goLive";
import { setLiveDetail } from "../../store/slices/liveDetailSlice";
import axios from "axios";
import { IoLogInOutline, IoSettingsOutline } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import { socket } from "../../utils/socket";
import Notification from "./Notification";
import { MdOutlineLogin } from "react-icons/md";
import { logoutApi } from "../../services/auth";
import { notificationIcon } from "../../assets/icons";
import { RiLogoutCircleLine } from "react-icons/ri";

const DashboardHeader = ({ title }) => {
  // const [mobileMenu, setMobileMenu] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutModal, setLogoutModal] = useState(false);
  const { showAuth } = useSelector((state) => state?.showAuth);
  // const [loading, setLoading] = useState(false);
  // const { liveDetail } = useSelector((state) => state?.liveDetail);

  // const fetchUserDetail = async () => {
  //   console.log("showAuth");
  //   if (getToken()) {
  //     try {
  //       const { data } = await fetchUserDetailApi({ token: getToken() });
  //       const { success, data: response } = data;
  //       if (success) {
  //         dispatch(setShowAuth(response));
  //       }
  //     } catch (e) {
  //       console.log("Error:-", e.message);
  //     }
  //   }
  // };

  // const fetchGoogleMeetHandler = async () => {
  //   if (getToken()) {
  //     try {
  //       const { data } = await axios.get(
  //         `${process.env.REACT_APP_API_URL}user/live/google-meet-auth`,
  //         setJwtToken()
  //       );

  //       const { data: liveMeetData, success, message, meta } = data;
  //       if (success) {
  //         dispatch(setLiveDetail(liveMeetData));
  //       }
  //     } catch (error) {
  //       dispatch(setLiveDetail({}));
  //       console.error(error?.message);
  //     }
  //   }
  // };

  // Logout Handler
  const logoutHandler = async () => {
    try {
      await logoutApi();
      localStorage.removeItem("logic_chat_token");
      setLogoutModal(false);
      navigate("/");
      toastMessage("Logout Successfully", "success", "Logout");
      socket.disconnect();
      dispatch(setShowAuth({}));
    } catch (error) {
      localStorage.removeItem("logic_chat_token");
      setLogoutModal(false);
      navigate("/");
      toastMessage("Logout Successfully", "success", "Logout");
      socket.disconnect();
      dispatch(setShowAuth({}));
    }

  };

  // useEffect(() => {
  //   fetchUserDetail();
  //   fetchGoogleMeetHandler();
  // }, [getToken()]);

  // useEffect(() => {
  //   document.body.classList.toggle("menuOpen", mobileMenu);
  // }, [mobileMenu]);

  const mobileMenu = () => {
    document.body.classList.toggle("menuOpen");
  };

  return (
    <>
      <div className="dashboard_header">
        <div className="dashboard_header_menu_wrap">
          <button
            className="logical_hamburger"
            id="menuButton"
            onClick={mobileMenu}
          >
            <GiHamburgerMenu className="open" />
          </button>

          <h5>{title}</h5>
        </div>

        <div className="content_right">
          {/* <div className="notification-icon">
            <FiBell />
          </div> */}
          <Dropdown className="custom_dropdown notification">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <img src={notificationIcon} alt="" />
            </Dropdown.Toggle>

            {/* ------------notification-call------------- */}
            <Notification />
          </Dropdown>

          <div className="custom_dropdown">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <img src={showAuth?.profilePicture || DP} /> <IoIosArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={"span"}>
                  <Link to="/dashboard/profile">
                    <IoSettingsOutline /> Profile
                  </Link>
                </Dropdown.Item>

                <Dropdown.Item as={"span"} className="inside_logout">
                  <Link
                    to="#"
                    onClick={(e) => {
                      setLogoutModal(true);
                      e.preventDefault();
                    }}
                  >
                    <RiLogoutCircleLine />
                    Logout
                  </Link>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      <LogoutModal
        show={logoutModal}
        handleClose={() => setLogoutModal(false)}
        action={logoutHandler}
      />
    </>
  );
};

export default DashboardHeader;
